import React, { useState } from 'react';
import {
  CardNumberElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from 'components/common/Button';
import CardDetails from './CardDetails';
import { makeStyles, Radio } from '@material-ui/core';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
  creditCard: {
    fontSize: 32,
    fontFamily: 'NimbusSanD-Bol',
    lineHeight: '38px',
  },
}));

const ErrorMessage = ({ children }) => (
  <Box marginTop={1} style={{ color: 'red' }}>
    {children}
  </Box>
);

const CheckoutForm = ({ onToken, isUpsell, paymentMethod, showAgreement }) => {
  const stripe = useStripe();
  const classes = useStyles();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [agree, setAgree] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (error) {
      setError(error.message);
      return;
    }

    if (event.currentTarget.value === 'payWith') {
      return onToken('');
    }

    const cardElement = elements.getElement(CardNumberElement);
    const payload = await stripe.createToken(cardElement, {});

    if (payload.error) {
      setError(payload.error);
    } else {
      return onToken(payload.token.id);
    }
  };

  return (
    <div>
      <Typography style={{ marginBottom: 24 }} className={classes.creditCard}>
        Enter your Credit Card details
      </Typography>
      {isUpsell && (
        <div style={{ textAlign: 'center' }}>
          <div>
            <Button
              value={'payWith'}
              onClick={handleSubmit}
              size="large"
              color="primary"
            >
              {' '}
              Pay with ****{paymentMethod[0].card.last4}
            </Button>{' '}
          </div>
          <div style={{ padding: '10px 0' }}>OR</div>
        </div>
      )}
      <div>
        <CardDetails setFormComplete={setCardComplete} />
      </div>
      {showAgreement && (
        <Box mt={2}>
          <Box marginBottom={4} display="flex" alignItems="center">
            <Box>
              <Radio
                className={classes.radio}
                disableRipple={true}
                size="small"
                color={'primary'}
                name="selected"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
              />
            </Box>
            <Typography
              component="div"
              variant="caption"
              style={{ fontSize: 14 }}
            >
              I have read and agree to WeAdmit{' '}
              <Link target="_blank" href="https://www.weadmit.com/terms-of-use">
                Terms of Use
              </Link>{' '}
              and{' '}
              <Link target="_blank" href="https://www.weadmit.com/privacy-policy">
                Privacy Policy
              </Link>
              .
            </Typography>
          </Box>
        </Box>
      )}
      {error && <ErrorMessage>{error.message}</ErrorMessage>}
      <Box marginTop={5}>
        <Button
          onClick={handleSubmit}
          size="large"
          variant="contained"
          color="primary"
          disabled={!cardComplete || (showAgreement && !agree)}
        >
          Submit Payment
        </Button>
      </Box>
    </div>
  );
};

export default CheckoutForm;
